import type {
  ContactSectionLink,
  AboutSectionInfoSection
} from '../pages/About';

export const ContactSectionLinks: ContactSectionLink[] = [
  {
    label: 'About.Github',
    href: 'https://github.com/processing/p5.js-web-editor'
  },
  {
    label: 'About.Instagram',
    href: 'https://www.instagram.com/p5xjs'
  },
  {
    label: 'About.Youtube',
    href: 'https://www.youtube.com/@ProcessingFoundation'
  },
  { label: 'About.X', href: 'https://x.com/p5xjs' },
  {
    label: 'About.Discord',
    href: 'https://discord.p5js.org'
  },
  {
    label: 'About.Forum',
    href: 'https://forum.processing.org/'
  }
];

export const AboutSectionInfo: AboutSectionInfoSection[] = [
  {
    header: 'About.NewP5',
    items: [
      {
        url: 'https://p5js.org/',
        title: 'About.Home',
        description: 'About.LinkDescriptions.Home'
      },
      {
        url: 'https://p5js.org/examples/',
        title: 'About.Examples',
        description: 'About.LinkDescriptions.Examples'
      },
      {
        url: '/code-of-conduct',
        title: 'About.CodeOfConduct',
        description: 'About.LinkDescriptions.CodeOfConduct'
      }
    ]
  },
  {
    header: 'About.Resources',
    items: [
      {
        url: 'https://p5js.org/libraries/',
        title: 'About.Libraries',
        description: 'About.LinkDescriptions.Libraries'
      },
      {
        url: 'https://p5js.org/reference/',
        title: 'About.Reference',
        description: 'About.LinkDescriptions.Reference'
      }
    ]
  },
  {
    header: 'About.GetInvolved',
    items: [
      {
        url: 'https://p5js.org/donate/',
        title: 'About.Donate',
        description: 'About.LinkDescriptions.Donate'
      },
      {
        url: 'https://github.com/processing/p5.js-web-editor',
        title: 'About.Contribute',
        description: 'About.LinkDescriptions.Contribute'
      },
      {
        url: 'https://github.com/processing/p5.js-web-editor/issues/new',
        title: 'About.Report',
        description: 'About.LinkDescriptions.Report'
      },
      {
        url: 'https://discourse.processing.org/',
        title: 'About.ForumCTA',
        description: 'About.LinkDescriptions.Forum'
      },
      {
        url: 'https://discord.p5js.org',
        title: 'About.DiscordCTA',
        description: 'About.LinkDescriptions.Discord'
      }
    ]
  }
];
